
<div class="body-content">
  <div class="logo">
    <img alt="Company Logo"  src="assets/images/uw-logo-en.svg" />
  </div>
  <div class="box1"></div>
  <div class="box2"></div>
  <div class="box3"></div>
  <div class="box4"></div>
  <div class="main">
    <div class="sideimage"><img alt="Welcome Side Image" src="assets/images/Layer_1.png" /></div>
    <div class="login-side">
      <div class="auth-container">

        <form class="login-form" [formGroup]="resetFormGrp">
          <div class="align-center">
            <h2>{{ "common.set_password" | translate }}</h2>
            <h3>{{this.email}}</h3>
          </div>
          <div class="warning-container">
            <p>
              {{ "auth.pwd_requirements" | translate }}
            </p>
            <ol>
              <li>{{ "auth.pwd_requirements_msg1" | translate }}</li>
              <li>{{ "auth.pwd_requirements_msg2" | translate }}</li>
              <li>{{ "auth.pwd_requirements_msg3" | translate }}</li>
              <li>{{ "auth.pwd_requirements_msg4" | translate }}</li>
              <li>{{ "auth.pwd_requirements_msg6" | translate }}</li>
              <li>{{ "auth.pwd_requirements_msg5" | translate }}</li>
            </ol>
          </div>
          @if (errorMessage) {
            <div class="error-container">
              {{this.errorMessage}}
            </div>
          }
          <div class="row">
            <div class="col-sm-12 form-group">
              <label for="password">
                <span>{{ "common.new_password" | translate }}</span>
                <strong>*</strong>
              </label>
              <input #newPassword id="password" type="password" matInput formControlName="password" class="uw-input" [errorStateMatcher]="matcher" >
              <div class="d-flex">
                <div>
                  <input type="checkbox" (click)="showPassword(newPassword)">
                </div>
                <div class="ml-2"> {{'common.show_password' | translate}} </div>
              </div>
              @if (resetFormGrp.dirty && resetFormGrp.get('password')?.errors?.pattern) {
                <span class="uw-error-message">
                {{  "auth.pwd_requirements_msg" | translate }}</span>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 form-group">
              <label for="confirmPassword">
                <span>{{ "common.confirm_password" | translate }}</span>
                <strong>*</strong>
              </label>
              <input #confirmPassword id="confirmPassword" type="password" matInput formControlName="confirmPassword"  class="uw-input"  [errorStateMatcher]="matcher">
              <div class="d-flex">
                <div>
                  <input type="checkbox" (click)="showPassword(confirmPassword)">
                </div>
                <div class="ml-2"> {{'common.show_password' | translate}} </div>
              </div>
              @if ( resetFormGrp.get('confirmPassword')?.dirty && resetFormGrp.get('confirmPassword')?.hasError('required')) {
                <mat-error>
                  {{ "common.confirm_password_is" | translate }} <strong>{{ "common.required" | translate }}</strong>
                </mat-error>
              }
              @if ( resetFormGrp.get('confirmPassword')?.dirty && resetFormGrp.get('confirmPassword')?.value !== resetFormGrp.get('password')?.value) {
                <mat-error>
                  {{ "common.confirm_password_mismatch_with_new_password" | translate }}
                </mat-error>
              }
            </div>
          </div>
          <div class="flex-column-center">
            <button  class="uw-default-button" [disabled]="!resetFormGrp.valid || resetFormGrp.get('confirmPassword')?.value !== resetFormGrp.get('password')?.value" (click)="setPassword()">{{'buttons.setPassword' | translate}}</button>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>
